'use client';
import { useRef, useEffect } from 'react';
import { Provider } from 'react-redux';
import { makeStore, AppStore } from '@/lib/redux/store';
import { clearCart } from '@/lib/redux/features/cart';

export default function StoreProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const storeRef = useRef<AppStore | null>(null);

  if (!storeRef.current) {
    storeRef.current = makeStore();
  }

  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === 'pending_order_id') {
        // pending removed -> payment completed in another tab
        if (!e.newValue) {
          try {
            storeRef.current?.dispatch(clearCart());
          } catch (err) {
            // ignore
          }
        }
      }
    };

    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return <Provider store={storeRef.current}>{children}</Provider>;
}
